import api from "@/config/api";

const path = "public/formular/employee/evaluation"

export default {

  get: (token) => {
    return api.get(`${path}/${token}`)
  },
  post: (evaluation, token) => {
    return api.post(path, evaluation, { params: { token } })
  }
}
